import React, { useCallback, useMemo } from 'react';
import { Box, NavigationLeftIcon } from '@common-fe/common-fe';
import styled from 'styled-components';

import { ModalWrapper } from '@/components/wrappers';

import PlanTerminationModalForm from './PlanTerminationModalForms/PlanTerminationModalForm';
import { TerminationSteps } from './store/usePlanTerminationModal.store';
import { usePlanTerminationModalStore } from './store';

const OneStepBackButton = styled(Box)`
  position: absolute;
  top: 16px;
  left: 16px;
  cursor: pointer;
`;

const PLAN_CUSTOM_NAME = 'Plan';

export const PlanTerminationModal = () => {
  const handleChangeVisibility = usePlanTerminationModalStore((state) => state.handleChangeVisibility);
  const modalVisible = usePlanTerminationModalStore((state) => state.modalVisible);
  const planName = usePlanTerminationModalStore((state) => state.planName);
  const handleReset = usePlanTerminationModalStore((state) => state.handleReset);
  const step = usePlanTerminationModalStore((state) => state.step);
  const handleSetStep = usePlanTerminationModalStore((state) => state.handleSetStep);

  const modalTitle = useMemo(() => {
    return `Terminate ${planName || PLAN_CUSTOM_NAME}`;
  }, [planName]);

  const handleSetVisible = useCallback(() => {
    handleChangeVisibility(false);
    handleReset();
  }, [
    handleChangeVisibility,
    handleReset,
  ]);

  return (
    <ModalWrapper
      testId="ModalWrapper"
      visible={modalVisible}
      onSetVisible={handleSetVisible}
      title={modalTitle}
      titleBoxStyle={{
        paddingBottom: '12px',
        paddingInline: '12px',
        textAlign: 'center',
      }}
    >
      {step === TerminationSteps.SET_TERMINATION_PARAMS ?  (
        <OneStepBackButton
          width="24px"
          height="24px"
          onClick={() => handleSetStep(TerminationSteps.SET_TERMINATION_DATE)}
        >
          <NavigationLeftIcon color="iconPrimary" />
        </OneStepBackButton>
      ) : null}
      <PlanTerminationModalForm onCancel={handleSetVisible} />
    </ModalWrapper>
  );
};